import React, { useState } from "react";
import { Link } from "react-router-dom";
import SubjectLink from "./SubjectLink";

import { observer } from "mobx-react";

import "./style.css";

interface SidebarSubjectHeaderProps {
    subject: any;
}

const SidebarSubjectHeader = observer(
    ({ subject }: SidebarSubjectHeaderProps) => {
        const [error, setError] = useState(false);
        if (!subject) {
            return <div></div>;
        }
        const widthClass = subject.canEdit ? "col-4" : "col-6";

        return (
            <div>
                <div className="sidebar-subject-header row">
                    <div className="col-12">
                        {subject.image_url && !error ? (
                            <span className="image">
                                <img
                                    width={40}
                                    height={40}
                                    src={subject.image_url}
                                    alt={`Image for ${subject.title}`}
                                    onError={() => setError(true)}
                                />{" "}
                            </span>
                        ) : null}
                        <span className="subject-title-text">
                            <div className="subject-link">
                                <Link
                                    className="subject-title"
                                    to={`/modquiz/subjects/${subject.user}/${subject.slug}`}
                                >
                                    {subject.title}
                                </Link>
                            </div>
                            <div className="text-muted user-link">
                                <Link to="/modquiz/subjects">
                                    {subject.user}
                                </Link>
                            </div>
                        </span>
                    </div>
                </div>
                <div className="row no-margin">
                    <SubjectLink
                        slug="simple_edit"
                        subject={subject}
                        title="Simple"
                        widthClass={widthClass}
                        description="A Simple table to edit multiple cards at a time quickly"
                    />
                    {subject.canEdit ? (
                        <SubjectLink
                            slug="settings"
                            subject={subject}
                            title="Settings"
                            description="Change Subject settings like title or whether or not it is public."
                            widthClass={widthClass}
                        />
                    ) : (
                        <></>
                    )}
                    <SubjectLink
                        slug="stats"
                        subject={subject}
                        title="Stats"
                        widthClass={widthClass}
                        description="Your stats and progress on this subject."
                    />
                </div>
            </div>
        );
    }
);

export { SidebarSubjectHeader };
